module.exports = __webpack_public_path__ + "static/media/Tennis Racquet.7cf5b2e2.jpg";